import starter from './app';
import './i18n';
import './lazyload-init';
import Home from './pages/Home';
import Login from './pages/Login';

import Register from './pages/areariservata/Register';


const _ = starter({
    home: Home,
    index: Home,
    login: Login,
    register: Register
});

